import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Teaser, TeaserImageOverlay } from '@as/cotopaxi';
import { safeRedirect } from '@as-react/common-utils';
import { useEffect, useRef } from 'react';
import { useElementIsVisible } from '../../hooks/useElementIsVisible';
import { useZitcha } from '../../hooks/useZitcha';
const MD_BREAKPOINT = 480;
function ZitchaBannerContainer({ location, banner }) {
    var _a, _b;
    const { collectClick, collectImpression } = useZitcha();
    const bannerRef = useRef(null);
    const isVisible = useElementIsVisible(bannerRef, { threshold: 0.01 });
    const collectData = {
        adFormat: 'native_banner',
        adId: banner.adId,
        placementId: `${location}-${banner.placement}`,
    };
    const handleClick = () => __awaiter(this, void 0, void 0, function* () {
        yield collectClick(collectData).finally(() => {
            /* @ts-expect-error creative.creative should not be there, but its returned */
            safeRedirect((banner.creative.url || banner.creative.creative.url));
        });
    });
    useEffect(() => {
        if (!isVisible) {
            return;
        }
        collectImpression(collectData);
    }, [isVisible]);
    const mobileBanner = (_a = banner === null || banner === void 0 ? void 0 : banner.creative.mobile) === null || _a === void 0 ? void 0 : _a[0];
    const desktopBanner = (_b = banner === null || banner === void 0 ? void 0 : banner.creative.desktop) === null || _b === void 0 ? void 0 : _b[0];
    if (!mobileBanner && !desktopBanner) {
        return null;
    }
    return (_jsx("div", { ref: bannerRef, children: _jsx(Teaser, { onClick: handleClick, imageOverlay: TeaserImageOverlay.DARK_66, image: {
                srcset: Object.assign(Object.assign({}, ((mobileBanner === null || mobileBanner === void 0 ? void 0 : mobileBanner.image) && {
                    [MD_BREAKPOINT]: mobileBanner.image,
                })), ((desktopBanner === null || desktopBanner === void 0 ? void 0 : desktopBanner.width) && {
                    [`${desktopBanner.width}`]: desktopBanner.image,
                })),
                isPicture: true,
                src: ((mobileBanner === null || mobileBanner === void 0 ? void 0 : mobileBanner.image) || (desktopBanner === null || desktopBanner === void 0 ? void 0 : desktopBanner.image)),
                alt: 'BANNER',
            } }) }));
}
export default ZitchaBannerContainer;
